import React, { useState } from 'react';
import HGForm from 'components/HGForm';
import { Auth } from 'aws-amplify';

const NewPasswordRequired = ({ user }) => {
    const [errorMessage, setErrorMessage] = useState(null);

    const createNewPassword = async (creds) => {
        try {
            await Auth.completeNewPassword(user, creds.password);
        } catch (error) {
            setErrorMessage(error.message);
            console.log(error);
        }
    };

    return (
        <div className="w-full">
            <h5 className="mb-3 text-center text-base font-medium text-foreground">
                Please create a new password
            </h5>
            <HGForm
                fields={{
                    password: 'New Password',
                    confirmPassword: 'Confirm Password',
                }}
                handleSubmit={createNewPassword}
                buttonText="Create New Password"
                errorMessage={errorMessage}
            />
        </div>
    );
};

export default NewPasswordRequired;
